import type { ReactNode } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

const backgroundStyle = css({
    "backgroundColor": "#fff",
    "padding": `${token("space.250")} 0`,
    "@media (max-width: 639.99px)": {
        padding: `${token("space.150")} 0`
    },
    "@media (min-width: 640px) and (max-width: 1279.99px)": {
        padding: `${token("space.150")} 0`
    }
});

const sectionStyle = css({
    "display": "flex",
    "flexWrap": "nowrap",
    "maxWidth": "1246px",
    "margin": "0 auto",
    "paddingBlockEnd": "56px",

    [media.below.md]: {
        gap: "2rem",
        flexDirection: "column"
    },
    "@media (max-width: 39.99rem)": {
        maxWidth: 288
    },
    "@media (min-width: 40rem) and (max-width: 767.99px)": {
        maxWidth: 592
    },
    "@media (min-width: 768px) and (max-width: 1023.99px)": {
        maxWidth: 636
    },
    "@media (min-width: 1024px) and (max-width: 1279.99px)": {
        maxWidth: 928
    },
    "@media (min-width: 1280px)": {
        paddingInlineStart: 40
    }
});

const unifiedSectionStyle = css({
    display: "flex",
    flexWrap: "nowrap",
    margin: "0 auto",
    flexDirection: "column",
    maxWidth: "1356px",
    gap: "2rem",
    paddingBlockEnd: "56px"
});

const variantBackgroundStyle = css({
    backgroundColor: "#fff",
    paddingBlockEnd: `56px`
});

const unifiedVariantBackgroundStyle = css({
    paddingInlineStart: 32,
    paddingInlineEnd: 32
});

export const TemplateSectionWrapper = ({
    children,
    shortPadding = false,
    columnOrientation = false
}: {
    children: ReactNode;
    shortPadding?: boolean;
    columnOrientation?: boolean;
}) => {
    if (columnOrientation) {
        return (
            <div css={[variantBackgroundStyle, unifiedVariantBackgroundStyle]}>
                <section css={unifiedSectionStyle}>{children}</section>
            </div>
        );
    }
    return shortPadding ? (
        <div css={variantBackgroundStyle}>
            <section css={sectionStyle}>{children}</section>
        </div>
    ) : (
        <div css={backgroundStyle}>
            <section css={sectionStyle}>{children}</section>
        </div>
    );
};
